import Router from "next/router";
import Tooltip from "rc-tooltip";
import React from "react";

import { SearchQuery } from "shared/data/reducers/types/storage";

import Checkbox from "@components/UI/Checkbox";
import FormattedMessage from "@components/UI/FormattedMessage";

import { ROUTES } from "@shared/constants";

import FilterOnlyAction from "./FilterOnlyAction";
import { ONLY_SELECTED, ONLY_SELECTED_NO_COMBINATIONS } from "./constants";
import {
  getAirlineOptionFilterValue,
  getAirlinesFilterType,
  getDefaultSelectedCheckboxValues,
} from "./helpers";
import { AirlinesFilterType } from "./types";

type Props = {
  query: SearchQuery;
  filterCompanies: any; // TransportCompany[]
  changeDefaultSelectedCheckboxFilter: (
    key: string,
    code: string,
    allValues: string[]
  ) => void;
  changeOnlyCheckboxFilter: (key: string, code: string) => void;
  activeFilter: number;
};

const FilterBox4 = ({
  query,
  filterCompanies,
  changeDefaultSelectedCheckboxFilter,
  changeOnlyCheckboxFilter,
  activeFilter,
}: Props) => {
  const transportCompanyCodes = (filterCompanies || []).map(
    (company) => company.Code
  );
  const activeAirlinesFilter = getAirlinesFilterType(query);

  const setAirlineOptionFilter = (type: AirlinesFilterType) => {
    const newQuery = getAirlineOptionFilterValue(query, type, activeFilter);

    Router.replace(
      {
        pathname: ROUTES.RESULTS,
        query: { ...newQuery },
      },
      undefined,
      { shallow: true, scroll: false }
    );
  };

  return (
    <div className="filters-box" id="filter-airlines">
      <span className="filters-label">
        <FormattedMessage id="Filters.airlines" />:
      </span>

      {filterCompanies &&
        filterCompanies.map((oCompany) => (
          <div
            key={oCompany.Code}
            className="filter-stars-checkbox filter-option-row"
          >
            <Checkbox
              customContainerClass="filter-airline-checkbox-container filter-option-checkbox"
              customLabelClass="filter-airline-checkbox-label filter-option-checkbox-label"
              label={
                <span className="filter-option-label-text">
                  {oCompany.Name.$t}
                </span>
              }
              onClick={() => {
                changeDefaultSelectedCheckboxFilter(
                  "transport_companies",
                  oCompany.Code,
                  transportCompanyCodes
                );
              }}
              checked={getDefaultSelectedCheckboxValues(
                query,
                "transport_companies",
                transportCompanyCodes
              ).includes(oCompany.Code)}
            />
            <FilterOnlyAction
              label={oCompany.Name.$t}
              onClick={() =>
                changeOnlyCheckboxFilter("transport_companies", oCompany.Code)
              }
            />
          </div>
        ))}
      <div className="filter-airline-spacer" />
      <Tooltip
        key="0"
        placement="left"
        mouseEnterDelay={0.5}
        mouseLeaveDelay={0.3}
        trigger={["hover"]}
        overlayStyle={{ zIndex: 2 }}
        overlayClassName="tooltip-background"
        overlay={
          <div>
            <FormattedMessage id="Filters.onlySelectedTooltip" />
          </div>
        }
      >
        <span>
          <Checkbox
            customCheckboxClass="filter-airline-options-checkbox"
            customContainerClass="filter-airline-options-checkbox-container"
            customLabelClass="filter-airline-options-checkbox-label"
            label={<FormattedMessage id="Filters.airlinesOnlySelected" />}
            onClick={() => setAirlineOptionFilter(ONLY_SELECTED)}
            checked={activeAirlinesFilter === ONLY_SELECTED}
          />
        </span>
      </Tooltip>

      <Tooltip
        key="1"
        placement="left"
        mouseEnterDelay={0.5}
        mouseLeaveDelay={0.3}
        trigger={["hover"]}
        overlayStyle={{ zIndex: 2 }}
        overlayClassName="tooltip-background"
        overlay={
          <div style={{ maxWidth: "300px" }}>
            <FormattedMessage id="Filters.onlySelectedNoCombinationsTooltip" />
          </div>
        }
      >
        <span>
          <Checkbox
            customCheckboxClass="filter-airline-options-checkbox"
            customContainerClass="filter-airline-options-checkbox-container"
            customLabelClass="filter-airline-options-checkbox-label"
            label={
              <FormattedMessage id="Filters.airlinesOnlySelectedNoCombinations" />
            }
            onClick={() =>
              setAirlineOptionFilter(ONLY_SELECTED_NO_COMBINATIONS)
            }
            checked={activeAirlinesFilter === ONLY_SELECTED_NO_COMBINATIONS}
          />
        </span>
      </Tooltip>
    </div>
  );
};

export default FilterBox4;
